<template>
  <common-dialog ref="dialog" title="软件需求 导出" width="1200px" @opened="onOpened" @closed="onClosed">
    <list
      row-key="RequirementId"
      ref="list"
      unit="软件需求"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="false"
      :get-data-func="api.list"
    >
      <template slot="toolbar-left">
        <span style="line-height: 28px;margin-left: 10px;">
          <span>文件名称：</span>
          <span>{{fileName}}</span>
          <span>.xlsx</span>
        </span>
      </template>
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" @click="exportExl()">确 定</el-button>
      </template>
      <template slot="table">
        <el-table-column prop="EmpName" label="申请人姓名" />
        <el-table-column prop="DpName" label="申请人部门" />
        <el-table-column prop="ApplyTypeName" label="申请类型" />
        <el-table-column prop="Title" label="申请标题" />
        <el-table-column prop="SystemName" label="系统名称" />
        <el-table-column prop="ModuleName" label="模块名称" />
        <el-table-column label="申请时间">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AddTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StatusText" label="当前状态" />
      </template>
    </list>
  </common-dialog>
</template>
<script>
import dialogMixins from "@/mixins/dialog";
import commonDialog from "@/components/common/dialog";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [dialogMixins, listMixin],
  components: { commonDialog, list },
  data() {
    return {
      fileName: "",
      autoWidth: true,
      bookType: "xlsx",
      params: {},
      api: require("@/api/bm/requirement").default,
    };
  },
  methods: {
    onOpened(data) {
      console.log("onOpened", data);
      this.fileName = data;
    },
    exportExl() {
      // if (this.fileName == "" || this.fileName == null) {
      //   this.$message.warning("请输入要保存的文件名称");
      //   return;
      // }
      let exportData = this.$refs.list.$refs.table.data;
      if (exportData.length == 0) {
        this.$message.warning("数据为空，无法导出");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "申请人姓名",
          "申请人部门",
          "申请类型",
          "申请标题",
          "系统名称",
          "模块名称",
          "申请时间",
          "当前状态",
        ];
        const filterVal = [
          "EmpName",
          "DpName",
          "ApplyTypeName",
          "Title",
          "SystemName",
          "ModuleName",
          "AddTime",
          "StatusText",
        ];
        const data = this.formatJson(filterVal, exportData);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.fileName,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        });
        loading.close();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "AddTime") {
            return this.$commonJs.toDateString(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    // getData() {
    //   console.log("this.$refs.list.getData");
    //   this.$nextTick(() => {
    //     this.$refs.list.getData();
    //   });
    // },
    onClosed() {
      this.fileName = "";
    },
  },
};
</script>